import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ApiClient from '../../BaseUrl/ApiClient';
import { Card, CardBody, CardHeader, Col, Container, Row, Button } from 'reactstrap';

const formatDate = (iso) => {
  if (!iso) return '-';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '-';
  const yyyy = d.getUTCFullYear();
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

function DetailLimitedTimeDeal() {
  const { dealId } = useParams();
  const history = useHistory();
  const [deal, setDeal] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!dealId) return;

    const fetchDealDetail = async () => {
      setLoading(true);
      try {
        const response = await ApiClient().get(`/admin/deal/limitedTimeDeals/${dealId}`);
        const dealData = response.data?.responseData?.deal;

        if (!dealData) {
          toast.error('Deal not found');
          return;
        }

        setDeal(dealData);
      } catch (err) {
        toast.error(err.response?.data?.responseMessage?.[0] || 'Failed to fetch deal details');
      } finally {
        setLoading(false);
      }
    };

    fetchDealDetail();
  }, [dealId]);

  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!deal) {
    return <div className="text-center mt-5">No deal found</div>;
  }

  return (
    <div className="page-content">
      <ToastContainer />
      <Container fluid>
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader className="d-flex align-items-center">
                <Button color="primary" onClick={() => history.goBack()}>
                  <i className="mdi mdi-arrow-left" />
                </Button>
                <h4 className="mb-0 ms-2">{deal.name} Deal Detail</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={4} className="mb-3">
                    <div
                      className="rounded overflow-hidden bg-light d-flex align-items-center justify-content-center"
                      style={{
                        width: '100%',
                        aspectRatio: '3 / 2',
                        maxHeight: '280px',
                      }}
                    >
                      {deal.dealPhoto?.url ? (
                        <img
                          src={deal.dealPhoto.url}
                          alt="deal"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      ) : (
                        <span className="text-muted">No Photo</span>
                      )}
                    </div>
                  </Col>

                  <Col md={8} className="text-left">
                    <Row>
                      <Col md={6}>
                        <p><strong>Name:</strong> {deal.name || '-'}</p>
                      </Col>
                      <Col md={6}>
                        <p><strong>Category:</strong> {deal.category?.name || '-'}</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <p><strong>Business:</strong> {deal.businessInfo?.businessName || '-'}</p>
                      </Col>
                      <Col md={6}>
                        <p>
                          <strong>Status:</strong>{' '}
                          <span
                            className={`badge ${deal.isActive ? 'bg-success' : 'bg-danger'}`}
                            style={{ padding: '0.4em 0.8em', borderRadius: '50px' }}
                          >
                            {deal.isActive ? 'Active' : 'Inactive'}
                          </span>
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <p><strong>Start Date:</strong> {formatDate(deal.startDate)}</p>
                      </Col>
                      <Col md={6}>
                        <p><strong>End Date:</strong> {formatDate(deal.endDate)}</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <p><strong>Description:</strong> {deal.description || '-'}</p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default DetailLimitedTimeDeal;
